module.exports = __webpack_public_path__ + "img/shuibiao.f97108ce.png";